import actions from "./actions";
import {mergeFieldsToTransactions} from "./helper";

const initState = {
    columns: [],
    reportData: null,
    readState: null,
    reportType: null,
    filterState: {
        contact_id: null,
        group_id: null,
        status: null,
        date_preset: null,
        date_range: [],
        transfer_status: null,
        sort_setting: {
            key: null,
            order: null,
        },
    },

    // for transaction list with custom fields
    readCustomFieldsState: null,
    reportCustomFields: [],
    requestedFieldKeys: [],

    // PDF Blob
    exportReportState: null,

};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.REPORT_SET_COLUMNS:
            return {
                ...state,
                columns: action.columns,
            };
        case actions.REPORT_READ_REQUEST:
            return {
                ...state,
                readState: 'request',
            };
        case actions.REPORT_READ_SUCCESS: {
            const reportData = { ...action.reportData };

            if (action.reportType === 'transaction_list') {
                const transactionListWithFields = mergeFieldsToTransactions(
                    action.reportData.report.transactions,
                    action.reportCustomFields,
                );
                reportData.report.transactions = transactionListWithFields;
            }

            return {
                ...state,
                readState: 'success',
                reportData,
                reportType: action.reportType,

                // for transaction list only
                reportCustomFields: action.reportCustomFields,
                requestedFieldKeys: action.requestedFieldKeys,
            };
        }
        case actions.REPORT_SET_FILTER_STATE:
            return {
                ...state,
                filterState: action.filterState,
            };
        case actions.REPORT_READ_CUSTOM_FIELDS_REQUEST:
            return {
                ...state,
                readCustomFieldsState: 'request',
            };
        case actions.REPORT_READ_CUSTOM_FIELDS_SUCCESS: {
            // assume that reportData is already present (from readReport Success)
            const reportDataWithFields = { ...state.reportData };
            // append custom fields to transaction list data
            reportDataWithFields.report.transactions = mergeFieldsToTransactions(
                reportDataWithFields.report.transactions,
                action.reportCustomFields,
            );
            return {
                ...state,
                readCustomFieldsState: 'success',
                reportCustomFields: action.reportCustomFields,
                reportData: reportDataWithFields,
                requestedFieldKeys: action.requestedFieldKeys,
            };
        }
        case actions.REPORT_EXPORT_REQUEST:
            return {
                ...state,
                exportReportState: 'request',
            };
        case actions.REPORT_EXPORT_SUCCESS:
            return {
                ...state,
                exportReportState: 'success',
            };
        case actions.REPORT_RESET_STATE:
            return initState;
        default:
            return state;
    }
}
